// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"155":"14b0613f","182":"f36752dd","537":"da281df7","597":"611d308b","606":"0fbb4ec0","670":"c342a631","805":"085ca7ff","876":"b3ebd638","970":"701d650e"}[chunkId] + ".js";
};